<script setup>
import { useNavigation } from "@/app/composables/useNavigation";
import {
  PRACTICE_NAME,
  CONTACT_INFO,
  SITE_LABELS,
  THERAPIST_NAME,
} from "@/content/site";
import ContentCard from "@/app/components/common/ContentCard.vue";

const { navigateToMore } = useNavigation();
</script>

<template>
  <div class="centering-flex-container fill-height">
    <div class="back-button-container">
      <button class="back-btn" @click="navigateToMore">
        {{ SITE_LABELS.backButtonToMoreInfoLabel }}
      </button>
    </div>
    <header class="header-section">
      <h1>Impressum</h1>
    </header>

    <ContentCard class="intro-card" noBox>
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>{{ PRACTICE_NAME }}</p>
      <p>{{ THERAPIST_NAME }}</p>
      <p>{{ CONTACT_INFO.address.street }}</p>
      <p>{{ CONTACT_INFO.address.zipCity }}</p>

      <h2>Kontakt</h2>
      <p>Telefon: {{ CONTACT_INFO.phone }}</p>
      <p>E-Mail: {{ CONTACT_INFO.email }}</p>

      <h2>Berufsbezeichnung</h2>
      <p>Heilpraktikerin für Psychotherapie ()</p>
      <p>Verliehen in: Deutschland</p>

      <h2>Berufsrechtliche Regelungen</h2>
      <p>Heilpraktikergesetz (HeilprG)</p>
      <p>Durchführungsverordnung zum Heilpraktikergesetz (HeilprGDV 1)</p>
      <p>
        Die berufsrechtlichen Regelungen können beim Bundesministerium der
        Justiz eingesehen werden:
        <a
          href="https://www.gesetze-im-internet.de"
          target="_blank"
          rel="noopener"
          >www.gesetze-im-internet.de</a
        >
      </p>

      <h2>Hinweis gemäß § 36 VSBG</h2>
      <p>
        Wir sind nicht bereit und nicht verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>
      <p>
        Plattform der EU-Kommission zur Online-Streitbeilegung:
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener"
          >https://ec.europa.eu/consumers/odr</a
        >
      </p>

      <h2>Haftungsausschluss</h2>
      <h3>Haftung für Inhalte</h3>
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
        Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
        jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
        Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>

      <h3>Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar.
      </p>

      <h3>Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers.
      </p>
    </ContentCard>
  </div>
</template>

<style scoped>
.centering-flex-container.fill-height {
  padding: 0 var(--spacing-md);
}

header {
  text-align: center;
  margin-bottom: var(--spacing-sm);
  flex-shrink: 0;
}

header h1 {
  font-family: var(--font-heading), serif;
  font-size: var(--font-size-xxxl);
  font-weight: var(--font-weight-light);
  color: var(--color-cream);
  margin-bottom: var(--spacing-xs);
  letter-spacing: var(--letter-spacing-widest);
  line-height: var(--line-height-tight);
  margin-left: var(--letter-spacing-widest);
}

.intro-card {
  flex: 0 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.intro-card :deep(a) {
  color: var(--color-cream);
  text-decoration: underline;
  transition: opacity var(--transition-normal);
}

.intro-card :deep(a:hover) {
  opacity: 0.8;
}

@media (max-width: 480px) {
  .centering-flex-container {
    justify-content: space-between;
    gap: var(--spacing-sm);
  }

  .header-section {
    margin-top: 4rem;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  header h1 {
    letter-spacing: var(--letter-spacing-wider);
    margin-bottom: var(--spacing-xxs);
  }

  .intro-card h2 {
    letter-spacing: var(--letter-spacing-tight);
    font-size: var(--font-size-xl);
    margin-bottom: var(--spacing-xxs);
  }
}
</style>
